import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { Rectangle, RenderTexture, utils, ExtensionType, extensions } from '@pixi/core';
var TEMP_RECT = new Rectangle();
var BYTES_PER_PIXEL = 4;
var _Extract = /*#__PURE__*/function () {
  function _Extract(renderer) {
    _classCallCheck(this, _Extract);
    this.renderer = renderer;
  }
  _createClass(_Extract, [{
    key: "image",
    value: function () {
      var _image = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(target, format, quality) {
        var image;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              image = new Image();
              _context.next = 3;
              return this.base64(target, format, quality);
            case 3:
              image.src = _context.sent;
              return _context.abrupt("return", image);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function image(_x, _x2, _x3) {
        return _image.apply(this, arguments);
      }
      return image;
    }()
  }, {
    key: "base64",
    value: function () {
      var _base = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(target, format, quality) {
        var canvas, blob;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              canvas = this.canvas(target);
              if (!(canvas.toDataURL !== void 0)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", canvas.toDataURL(format, quality));
            case 3:
              if (!(canvas.convertToBlob !== void 0)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 6;
              return canvas.convertToBlob({
                type: format,
                quality: quality
              });
            case 6:
              blob = _context2.sent;
              _context2.next = 9;
              return new Promise(function (resolve) {
                var reader = new FileReader();
                reader.onload = function () {
                  return resolve(reader.result);
                };
                reader.readAsDataURL(blob);
              });
            case 9:
              return _context2.abrupt("return", _context2.sent);
            case 10:
              throw new Error("Extract.base64() requires ICanvas.toDataURL or ICanvas.convertToBlob to be implemented");
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function base64(_x4, _x5, _x6) {
        return _base.apply(this, arguments);
      }
      return base64;
    }()
  }, {
    key: "canvas",
    value: function canvas(target, frame) {
      var renderer = this.renderer;
      var resolution;
      var flipY = false;
      var renderTexture;
      var generated = false;
      if (target) {
        if (target instanceof RenderTexture) {
          renderTexture = target;
        } else {
          renderTexture = this.renderer.generateTexture(target);
          generated = true;
        }
      }
      if (renderTexture) {
        var _frame;
        resolution = renderTexture.baseTexture.resolution;
        frame = (_frame = frame) !== null && _frame !== void 0 ? _frame : renderTexture.frame;
        flipY = false;
        renderer.renderTexture.bind(renderTexture);
      } else {
        resolution = renderer.resolution;
        if (!frame) {
          frame = TEMP_RECT;
          frame.width = renderer.width;
          frame.height = renderer.height;
        }
        flipY = true;
        renderer.renderTexture.bind(null);
      }
      var width = Math.round(frame.width * resolution);
      var height = Math.round(frame.height * resolution);
      var canvasBuffer = new utils.CanvasRenderTarget(width, height, 1);
      var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
      var gl = renderer.gl;
      gl.readPixels(Math.round(frame.x * resolution), Math.round(frame.y * resolution), width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
      var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);
      _Extract.arrayPostDivide(webglPixels, canvasData.data);
      canvasBuffer.context.putImageData(canvasData, 0, 0);
      if (flipY) {
        var target2 = new utils.CanvasRenderTarget(canvasBuffer.width, canvasBuffer.height, 1);
        target2.context.scale(1, -1);
        target2.context.drawImage(canvasBuffer.canvas, 0, -height);
        canvasBuffer.destroy();
        canvasBuffer = target2;
      }
      if (generated) {
        renderTexture.destroy(true);
      }
      return canvasBuffer.canvas;
    }
  }, {
    key: "pixels",
    value: function pixels(target, frame) {
      var renderer = this.renderer;
      var resolution;
      var renderTexture;
      var generated = false;
      if (target) {
        if (target instanceof RenderTexture) {
          renderTexture = target;
        } else {
          renderTexture = this.renderer.generateTexture(target);
          generated = true;
        }
      }
      if (renderTexture) {
        var _frame2;
        resolution = renderTexture.baseTexture.resolution;
        frame = (_frame2 = frame) !== null && _frame2 !== void 0 ? _frame2 : renderTexture.frame;
        renderer.renderTexture.bind(renderTexture);
      } else {
        resolution = renderer.resolution;
        if (!frame) {
          frame = TEMP_RECT;
          frame.width = renderer.width;
          frame.height = renderer.height;
        }
        renderer.renderTexture.bind(null);
      }
      var width = Math.round(frame.width * resolution);
      var height = Math.round(frame.height * resolution);
      var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
      var gl = renderer.gl;
      gl.readPixels(Math.round(frame.x * resolution), Math.round(frame.y * resolution), width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
      if (generated) {
        renderTexture.destroy(true);
      }
      _Extract.arrayPostDivide(webglPixels, webglPixels);
      return webglPixels;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer = null;
    }
  }], [{
    key: "arrayPostDivide",
    value: function arrayPostDivide(pixels, out) {
      for (var i = 0; i < pixels.length; i += 4) {
        var alpha = out[i + 3] = pixels[i + 3];
        if (alpha !== 0) {
          out[i] = Math.round(Math.min(pixels[i] * 255 / alpha, 255));
          out[i + 1] = Math.round(Math.min(pixels[i + 1] * 255 / alpha, 255));
          out[i + 2] = Math.round(Math.min(pixels[i + 2] * 255 / alpha, 255));
        } else {
          out[i] = pixels[i];
          out[i + 1] = pixels[i + 1];
          out[i + 2] = pixels[i + 2];
        }
      }
    }
  }]);
  return _Extract;
}();
var Extract = _Extract;
Extract.extension = {
  name: "extract",
  type: ExtensionType.RendererSystem
};
extensions.add(Extract);
export { Extract };